<template lang="pug">
v-app
  section
    .d-flex.row.flex-row.align-items-end.mb-4
      .col-12
        h2 
          i Desarrollo Personal (propios)
    .d-flex.row.flex-row.align-items-start
      .col-5
        .card.p-4.ad_border1-secondary.rounded-xl
            .form-group.row
              .col-12
                .ad_select.ad_border1-primary
                  select(v-model='selectedCategoria', @change='getSubByCat($event)')
                    option(:value="null" disabled) Selecciona Categoría
                    option(:value="category" v-for="category in categories") {{category.name}}
            .form-group.row
              .col-12
                .ad_select.ad_border1-primary
                   select(v-model='selectedObjetivoDesarrollo' )
                    option(:value="null" disabled) Selecciona Objetivo de desarrollo
                    option(:value="objetivo" v-for="objetivo in subcategories") {{objetivo.name}}
            .form-group.row
              .col-12
                textarea.form-control(placeholder="Agregar comentario (opcional)", v-model="comment")
            .form-group.row.mt-3
              .col-12.d-flex.justify-content-end
                button.btn.btn-secondary.btn__large(:class='{disabled : !selectedObjetivoDesarrollo}' @click="create()")
                  | Agregar
                  i.fas.fa-plus.border.border-white.rounded-circle.p-1.ml-2

      .col-7
        .card.p-4.ad_border1-secondary.rounded-xl
          h3.mb-4.ad_text-primary
            i Objetivos de Desarrollo Personal
          h5 En proceso
          .row.mb-3
              table.w-100.table-rounded-body.table-rounded-body_gray
                thead
                  tr
                    th.font-weight-bold Objetivo
                    th.font-weight-bold Categoría
                    th
                    th
                    th
                tbody
                  tr(v-for="value in pcs.pendientes")
                    td
                      div
                        | {{ value.subcategory ? value.subcategory.name : '' | truncate( 40, '...') }}
                    td.text-left
                      div
                        | {{ value.category ? value.category.name : '' | truncate( 40, '...')}}
                    td
                      div
                        span.ad_text-warning.text-nowrap
                          | {{ value.creation_date | WeekDuration}}&deg; sem
                    td
                      div.px-0
                        a.no-decoration(title="Comentarios", @click.stop='getDetailPC(value._id)')
                          i.icono.icono-comentarios.ad_text-primary
                    td
                      div
                        button.btn.btn-secondary.px-3(@click='openCloseModal(value)')        
                          | Actualizar  

          h5 Nuevos
          .row.mb-3
              table.w-100.table-rounded-body.table-rounded-body_gray
                thead
                  tr
                    th.font-weight-bold Objetivo
                    th.font-weight-bold Categoría
                    th
                    th
                    th
                tbody
                  tr(v-for="value in pcs.nuevos")
                    td
                      div
                        | {{ value.subcategory ? value.subcategory.name : '' | truncate( 40, '...') }}
                    td.text-left
                      div
                        | {{ value.category ? value.category.name : '' | truncate( 40, '...')}}
                    td
                      div
                        span.ad_text-warning.text-nowrap
                          | {{ value.creation_date | WeekDuration}}&deg; sem
                    td
                      div.px-0
                        a.no-decoration(title="Comentarios", @click.stop='getDetailPC(value._id)')
                          i.icono.icono-comentarios.ad_text-primary
                    td
                      div
                        a.btn-icon.ad_bg-secondary.border-btnicon-secondary(title="Eliminar", @click='removePersonalCommit(value._id)')
                          i.fas.fa-times.rounded-circle.text-white
                    td(v-if='value.name == "Nuevos"')
                      div
                        button.btn-icon.p-0.ad_text-danger.border-btnicon-danger.rounded-circle
                          i.fas.fa-times.p-0
          .col-12.text-center.rounded-lg.ad_bg-gray.pt-3(v-show='pcs.length == 0')
            p.muted Aún no ha seleccionado nuevos objetivos      
    
    v-navigation-drawer(v-model='drawer2', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentarios
      section.py-4.px-2.overflowy-auto
        .col
          label
            i.icono.icono-objetivos.ad_text-primary.mr-1
            | {{(personalcommitment) ? personalcommitment.subcategory.name : ''}}
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='comment_add')
          .form-group.justify-content-between
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer2 = false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="addCommentToPC(personalcommitment._id)")
              | Agregar comentario
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Anteriores
          div(v-if="personalcommitment")
            .row.mb-3(v-for='comm in personalcommitment.comments')
              .col-4.pr-0
                p.font-weight-bold.m-0 {{comm.user}}
                small.d-block {{moment(comm.creation_date) | DateFormat}}
                small.d-block {{moment(comm.creation_date) | HourFormat}} hrs.
              .col-8.pl-0
                .dialog-box
                  p {{comm.description}}

                
  v-navigation-drawer(v-model='closeDrawer', app='', temporary='', right='', width='500')
    header.ad_bg-primary.pt-5.pb-2.px-4
      h3.text-white.mt-4
        i Actualizar objetivo personal
    section.py-4.px-2.overflowy-auto
      .col-5
          c-form-radio.ad_radio.ad_radio-cumple(name="cumplimiento" v-model="cumplimiento" value="true" label="Cumple")
          c-form-radio.ad_radio.ad_radio-nocumple(name="cumplimiento" v-model="cumplimiento" value="false" label="No cumple")
      .col-12.mt-4
        .form-group.mt-4
          textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='comment')
        .form-group.justify-content-between
          button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="closeDrawer = false")
            i.far.fa-times-circle.fa-1x.mr-1.align-bottom
            | Cancelar
          button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="continuePC()")
            | Continuar compr.
            i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
          button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="closePC()")
            | Cerrar compr.
            i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import Flatpickr from 'vendors/cover/vendors/flatpickr'

export default {
  name: 'DesarrolloPersonal',
  props: ['clickedNext', 'currentStep'],
  components: {
     Flatpickr
  },
  data() {
      return {
        menu: false,
        date: null, 
        cumplimiento: null,
        comment_add: null,
        categories: [],
        subcategories: [],
        comment: '',
        user: null,
        pcs: { nuevos: [], pendientes: [] },
        personalcommitment: null,
        drawer: null,
        drawer2: false,
        closeDrawer: null,
        pendingObjective: '',
        overlay: false,
        moveobjetivo: false,
        selectedObjetivoDesarrollo: null,
        selectedCategoria: null,
        registroIA: 0,
      }
  },
  methods: {
    moment,
    ...mapActions('category', [
      'categoriesList'
    ]),
    ...mapActions('subcategory', [
      'byCategoryId'
    ]),
    ...mapActions('personalcommitments', [
      'createPC', 
      'getPcByIdPlan', 
      'getPCById', 
      'addCommentToPersonalCommitment', 
      'deletePersonalCommitment',
      'closePersonalCommitment',
      'continuePersonalCommitment'
    ]),
    create() {
      const vm = this
      if (vm.selectedCategoria != null) {
        if (vm.selectedObjetivoDesarrollo != null) {
          let currentWeek = moment().isoWeek()
          let comments = []
          if (vm.comment) {
            comments.push({
              user: vm.user.name,
              date: moment(),
              text: vm.comment
            })
          }
          let pc = {
            name: `Desarrollo Personal semana ${currentWeek}`,
            user: vm.user.id,
            comments: comments,
            category: vm.selectedCategoria,
            subcategory: vm.selectedObjetivoDesarrollo,
            plan: vm.plan._id
          }
          vm.createPC(pc).then(() => {
            vm.pcs = vm.$store.getters['personalcommitments/getpersonalCommitments']
            const loading = vm.$toast.loading('Creando...')
            vm._clearForm()
            if(vm.pcs.nuevos.length > 0) {
              vm.$emit('can-continue', {value: true});
            } else {
              vm.$emit('can-continue', {value: false});
            }
            loading.hide()
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Desarrollo Personal creado',
              closeable: true,
              duration: 5000
            })
          }, (error) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error,
              closeable: true,
              duration: 5000
            })
          })
        } else {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: 'Debe agregar la subcategoria',
            closeable: true,
            duration: 5000
          }) 
        }
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe agregar la categoria',
          closeable: true,
          duration: 5000
        })
      }
    },
    getDetailPC(id) {
      const vm = this
      vm.getPCById(id).then(() => {        
        vm.personalcommitment = vm.$store.getters['personalcommitments/getpersonalCommitment']
        vm.drawer2 = !vm.drawer2
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    getSubByCat() {
      const vm = this
      vm.byCategoryId(vm.selectedCategoria._id).then(() => {
        vm.selectedObjetivoDesarrollo = null
        vm.subcategories = vm.$store.getters['subcategory/getSubcategories']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    _clearForm() {
      const vm = this
      vm.selectedObjetivoDesarrollo = null
      vm.selectedCategoria = null
      vm.comment = ''
    },
    openCloseModal(value) {
      const vm = this;
      vm.pendingObjective = value
      vm.closeDrawer = true
    },
    closePC() {
      const vm = this
      if (vm.cumplimiento != null) {
        const data = {
          id: vm.pendingObjective._id, accomplished: vm.cumplimiento
        }
        vm.closePersonalCommitment(data).then(() => {          
          vm.addCommentToPersonalCommitment({
            _id: vm.pendingObjective._id,
            description: vm.comment,
            user: vm.user.name
          }).then(() => {
            vm.pcs = vm.$store.getters['personalcommitments/getpersonalCommitments']
            vm.closeDrawer = false
            vm.cumplimiento = null
            if(vm.pcs.nuevos.length > 0) {
              vm.$emit('can-continue', {value: true});
            } else {
              vm.$emit('can-continue', {value: false});
            }
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Objetivo cerrado',
              closeable: true,
              duration: 5000
            })
          }, (error) => {
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error.payload.message,
              closeable: true,
              duration: 5000
            })
          }).catch(err => {
            console.log(err)
          })          
        }, (error) => {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe especificar si el objetivo fue cumplido',
          closeable: true,
          duration: 5000
        })
      }
    },
    addCommentToPC(id) {
      const vm = this
      let comm = {
        user: vm.user.name,
        date: moment(),
        text: vm.comment_add
      }
      vm.addCommentToPersonalCommitment({
        _id: id,
        description: vm.comment_add,
        user: vm.user.name
      }).then(() => {
        vm.personalcommitment.comments.push(comm)
        vm.drawer2 = false        
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      }).catch(err => {
        console.log(err)
      })
    },
    removePersonalCommit(id) {
      const vm = this;
      vm.deletePersonalCommitment(id).then(result => {
        if (result) {
          vm.pcs = vm.$store.getters['personalcommitments/getpersonalCommitments']
          if(vm.pcs.nuevos.length > 0) {
            vm.$emit('can-continue', {value: true});
          } else {
            vm.$emit('can-continue', {value: false});
          }
          vm.$notify({
            type: 'success',
            title: 'Notificación',
              content: 'Compromiso personal eliminado',
            closeable: true,
            duration: 5000
          })
        }
      })    
    },
    continuePC() {
      const vm = this
      const data = {
        pc: vm.pendingObjective, plan: vm.plan
      }
      vm.continuePersonalCommitment(data).then(() => {        
        vm.addCommentToPersonalCommitment({
            _id: vm.pendingObjective._id,
            description: vm.comment,
            user: vm.user.name
          }).then(() => {
            vm.pcs = vm.$store.getters['personalcommitments/getpersonalCommitments']
            vm.closeDrawer = false
            vm.cumplimiento = null
            if(vm.pcs.nuevos.length > 0) {
              vm.$emit('can-continue', {value: true});
            } else {
              vm.$emit('can-continue', {value: false});
            }
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Objetivo continuado',
              closeable: true,
              duration: 5000
            })
          }, (error) => {
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error.payload.message,
              closeable: true,
              duration: 5000
            })
          }).catch(err => {
            console.log(err)
          })        
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    }
  },
  watch: {
    currentStep: function(){
      const vm = this
      if(vm.pcs.nuevos.length > 0) {
        vm.$emit('can-continue', {value: true});
      } else {
        vm.$emit('can-continue', {value: false});
      }
    },
    pcs: function() {
      const vm = this
      if(vm.pcs.nuevos.length > 0) {
        vm.$emit('can-continue', {value: true});
      } else {
        vm.$emit('can-continue', {value: false});
      }
    }
  },
  mounted() {
    const vm = this
    const loading = vm.$toast.loading('Cargando...')
    vm.plan = vm.$store.getters['plan/getPlan']
    vm.user = vm.$store.getters['auth/getUserInfo']
    vm.categoriesList().then(() => {
      vm.categories = vm.$store.getters['category/getCategories']
    }, (error) => {
      loading.hide()
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: error.payload.message,
        closeable: true,
        duration: 5000
      })
    })
    const data = {
      id: vm.plan._id,
      user: vm.user.id
    }
    vm.getPcByIdPlan(data).then(() => {
      vm.pcs = vm.$store.getters['personalcommitments/getpersonalCommitments']
      if(vm.pcs.nuevos.length > 0) {
        vm.$emit('can-continue', {value: true});
      } else {
        vm.$emit('can-continue', {value: false});
      }
      loading.hide()
    }, (error) => {
      loading.hide()
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: error.payload.message,
        closeable: true,
        duration: 5000
      })
    })    
  },
    computed: {
    objectives () {
      if (!this.selectedCategoria) {
        return
      }
      return this.categories[this.selectedCategoria].map(categorie => {
        return categorie.categoriesObjective
      })
    },
  }
};

</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/views/ps-desarrollo.vue